import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import logo from './logo.png';

export default function LoginPage() {
  const { login } = useAuth();
  const [form, setForm]       = useState({ username: '', password: '' });
  const [error, setError]     = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await axios.post('/api/auth/login', form);
      login(data.token, data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Σφάλμα σύνδεσης');
    } finally { setLoading(false); }
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center',
      background: 'var(--bg)', padding: 24,
    }}>
      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: 36 }}>
        <img src={logo} alt="Mr. Gadget" style={{ width: 180, borderRadius: 16, marginBottom: 12 }} />
        <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>Σύστημα Διαχείρισης Επισκευών</div>
      </div>

      {/* Card */}
      <div className="card" style={{ width: '100%', maxWidth: 380 }}>
        <div className="card-title" style={{ marginBottom: 24 }}>Σύνδεση</div>

        {error && <div className="alert alert-error" style={{ marginBottom: 18 }}>{error}</div>}

        <form onSubmit={handleLogin}>
          <div className="field" style={{ marginBottom: 16 }}>
            <label>Username</label>
            <input type="text" value={form.username} autoFocus autoComplete="username"
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              placeholder="Εισάγετε username" />
          </div>
          <div className="field" style={{ marginBottom: 24 }}>
            <label>Password</label>
            <input type="password" value={form.password} autoComplete="current-password"
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="Εισάγετε password" />
          </div>
          <button type="submit" className="btn-primary"
            style={{ width: '100%', padding: '12px', fontSize: 15 }} disabled={loading}>
            {loading ? 'Σύνδεση...' : 'Σύνδεση'}
          </button>
        </form>

        <div style={{ marginTop: 16, fontSize: 12, color: 'var(--text-muted)', textAlign: 'center' }}>
          Για δημιουργία λογαριασμού επικοινωνήστε με τον διαχειριστή.
        </div>
      </div>

      <div style={{ marginTop: 60, color: 'var(--text-muted)', fontSize: 12, textAlign: 'center' }}>
        <span>© {new Date().getFullYear()} <span>The Mr Gadget</span>| Developed by Dimitrios Gkountanos</span>
      </div>
    </div>
  );
}
